<mat-horizontal-stepper class="stepper" [linear]="isLinear" #stepper>
  <!-- lease-endow stock -->
  <mat-step
    *ngIf="
      (leaseEndowType === 'stock' && steps.get('stockVehicle')) ||
      requestType === requestTypeEnum.campaigns ||
      requestType === requestTypeEnum.vo
    "
  >
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template class="stepper--title" matStepLabel>
      {{ 'stepVehicleFinder' | i18next }}
    </ng-template>
    <app-stock-vehicles
      [requestType]="requestType"
      [user]="user"
      (selectedVehicleChange)="onVehiclesSelected($event)"
      (carList)="handleCarList($event)"
      (onBack)="initStep()"
      (campaignEmit)="setCampaign($event)"
    ></app-stock-vehicles>
  </mat-step>
  <!-- Buscador de vehículos -->
  <mat-step
    [stepControl]="vehicleFinderFormGroup"
    *ngIf="steps.get('vehicle-finder')"
  >
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template class="stepper--title" matStepLabel>
      {{ 'stepVehicleFinder' | i18next }}
    </ng-template>
    <app-step-vehicle-finder
      #stepTwo
      [stepper]="stepper"
      [requestType]="requestType"
      (vehicleFinderEmitter)="onVehiclesSelected($event)"
      (backStepEmitter)="backStep()"
    ></app-step-vehicle-finder>
  </mat-step>
  <!-- Información solicitud -->
  <mat-step
    *ngIf="steps.get('request-info')"
    [stepControl]="requestInfoFormGroup"
  >
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template class="stepper--title" matStepLabel>
      {{ stepTitle }}
    </ng-template>
    <app-step-request-info
      #stepFour
      [stepper]="stepper"
      [user]="user"
      [requestType]="requestType"
      [vehiclesArr]="vehiclesArr"
      (vehicleTypeEmitter)="typeEvent($event)"
      (requestInfoFormEmitter)="requestInfoFormUpdate($event)"
      (backStepEmitter)="backStep()"
      (carPoolDataEmitter)="updateCarPoolData($event)"
    ></app-step-request-info>
  </mat-step>
  <!-- Controladores y Probadores -->
  <mat-step [completed]="isApproversCompleted" *ngIf="steps.get('approvers')">
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template class="stepper--title" matStepLabel>
      {{ 'stepApprovers' | i18next }}
    </ng-template>
    <app-step-approvers
      #stepThree
      [stepper]="stepper"
      [requestType]="requestType"
      [user]="user"
      [loanType]="loanType"
      [resetStep]="resetStep"
      [moreThan14days]="moreThan14days"
      (authorizerControllerEmitter)="updateControllers($event)"
      (approversEmitter)="nextStepApprovers()"
      (backStepEmitter)="backStep()"
    ></app-step-approvers>
  </mat-step>
  <!-- Configuración coche -->
  <mat-step
    [stepControl]="vehicleInfoFormGroup"
    *ngIf="steps.get('car-config')"
  >
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template id="carConfig" class="stepper--title" matStepLabel>
      {{ 'stepCarConfig' | i18next }}
    </ng-template>
    <app-step-car-config
      #stepFive
      [stepper]="stepper"
      [requestType]="requestType"
      [loanType]="loanType"
      [totalDays]="totalDays"
      [modelList]="modelList"
      [carPoolCenterDate]="carPoolCenterDate"
      [isDetail]="false"
      (updateVehicleInfoDataEmitter)="updateVehicleInfoData($event)"
      (backStepEmitter)="backStep()"
    >
    </app-step-car-config>
  </mat-step>
  <!-- Vehiculo de sustitución -->
  <mat-step
    [stepControl]="replacementVehicleFormGroup"
    *ngIf="!isFirstAssign && steps.get('replacementvehicle')"
  >
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template id="replacementVehicle" class="stepper--title" matStepLabel>
      {{ 'stepReplaceVehicle' | i18next }}
    </ng-template>
    <app-step-replacement-vehicle
      #stepSix
      [stepper]="stepper"
      [requestType]="requestType"
      [vehiclesArr]="vehiclesArr"
      [carType]="carType"
      (vehicleReplacementEmitter)="updateReplacementVehicleData($event)"
      (backStepEmitter)="backStep()"
    ></app-step-replacement-vehicle>
  </mat-step>
  <!-- Adjuntar documentos -->
  <mat-step *ngIf="steps.get('uploadDocuments')">
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template class="stepper--title" matStepLabel>
      {{ 'uploadDocuments' | i18next }}
    </ng-template>
    <app-step-documentation
      #stepSeven
      [stepper]="stepper"
      (backStepEmitter)="backStep()"
      (sendRequestEmitter)="saveDoc($event)"
    ></app-step-documentation>
  </mat-step>
  <!-- Información adicional -->
  <mat-step *ngIf="steps.get('additionalInfo')">
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template id="confirm" class="stepper--title" matStepLabel>
      {{ 'additionalInfo' | i18next }}
    </ng-template>
    <ng-template matStepContent>
      <app-step-additional-info
        [stepper]="stepper"
        [requestType]="requestType"
        [campaign]="campaign"
        [loanType]="loanType"
        (sendRequestEmitter)="gotoSummary($event)"
        (backStepEmitter)="backStep()"
      ></app-step-additional-info>
    </ng-template>
  </mat-step>

  <!-- Resumen -->
  <mat-step *ngIf="steps.get('resume')">
    <ng-template matStepperIcon="edit">
      <mat-icon>done</mat-icon>
    </ng-template>
    <ng-template id="confirm" class="stepper--title" matStepLabel>
      {{ 'summary' | i18next }}
    </ng-template>
    <app-step-summary
      [car]="selectedCar"
      [additionalInfo]="additionalInfo"
      [campaignType]="campaignType"
      [campaign]="campaign"
      [user]="user"
      [docInfo]="documentationInfo"
      [requestType]="requestType"
      (onResponse)="onSummaryResponse($event)"
    ></app-step-summary>
  </mat-step>
</mat-horizontal-stepper>
